import React from 'react';
import { useSelector } from 'react-redux';
import { GridWrapper } from '@yme/atoms/grid';
import { IMAGE_DEFAULT_ASPECT_RATIO } from '@yme/common/constants';
import { IndentWrapper } from '@yme/components/Separator';
import { getRTL } from '@yme/selectors/common';
import { ImageHolder } from './ImageHolder';
import { IMAGE_DATA_TEST_ID } from './constants';
export function Image(props) {
    const { linkURL = '', srcSet = [], alt = '', isCustomGrid, isRemoveBottomIndent, ...rest } = props;
    const isRightToLeft = useSelector(getRTL);
    const ImageAtomAttrs = {
        ...rest,
        srcSet,
        linkURL,
        alt,
        isRightToLeft,
        ...IMAGE_DEFAULT_ASPECT_RATIO,
    };
    if (isCustomGrid) {
        return (React.createElement(IndentWrapper, { dataTestId: IMAGE_DATA_TEST_ID, isRemoveBottomIndent: isRemoveBottomIndent },
            React.createElement(GridWrapper, null,
                React.createElement(ImageHolder, { ...ImageAtomAttrs }))));
    }
    return (React.createElement(IndentWrapper, { dataTestId: IMAGE_DATA_TEST_ID, isRemoveBottomIndent: isRemoveBottomIndent },
        React.createElement(ImageHolder, { ...ImageAtomAttrs })));
}
Image.displayName = 'Image_AEMComponent';
